import features from '@nobia/zeus-components/lib/features'
import settings from '@nobia/zeus-components/lib/settings'
import moment from 'moment'
import React, { createContext, useContext, useMemo } from 'react'

import { useAccountContext } from '../AccountContext'

const today = moment().format('YYYY-MM-DD')

const parseDate = dateStr => {
  const date = moment(dateStr)
  return date?.isValid() ? date : null
}

const campaignStarted = date => {
  const startDate = parseDate(date)
  return startDate ? moment(today).isSameOrAfter(startDate) : false
}

const campaignEnded = date => {
  const endDate = parseDate(date)
  return endDate ? moment(today).isAfter(endDate) : false
}

const defaultCampaign = {
  title: '',
  preamble: '',
  text: '',
  link: '',
  image: '',
  startDate: '',
  endDate: '',
  selectedStores: [],
}

const CampaignContext = createContext({
  campaign: { ...defaultCampaign },
})

export const CampaignProvider = props => {
  const value = useMemo(
    () =>
      settings.campaigns.map(c => ({
        title: c.title,
        preamble: c.preamble,
        text: c.text,
        link: c.link,
        image: c.image,
        startDate: c.startDate,
        endDate: c.endDate,
        selectedStores: c.selectedStores,
      })),
    []
  )

  return <CampaignContext.Provider value={value} {...props} />
}

export const useCampaign = () => {
  const { store } = useAccountContext()
  const campaigns = useContext(CampaignContext)

  return useMemo(() => {
    if (features.campaign === false) {
      return null
    }

    return campaigns.filter(c => {
      const started = campaignStarted(c.startDate)
      const ended = campaignEnded(c.endDate)
      if (!started || ended) {
        return false
      }
      if (c.selectedStores?.length > 0) {
        return c.selectedStores.some(store?.id)
      }
      return true
    })[0]
  }, [store, campaigns])
}
